import { useEffect, useRef, useState } from "react";
import { Header } from "../../widgets";
import { Loader } from "../../widgets/loaders/Loader";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getItemLocalStorage } from "../../features/webStorageSaver";
import ToastMessageContainer from "../../widgets/toastMessageContainer/ToastMessageContainer";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../stateManagement/reducers";

// Страница для восстановления пароля
export function RemindPasswordPage() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [databaseOptions, setDataBaseOptions] = useState<any>();

    // определения из библиотеки react-hook-form
    const {
        register,
        handleSubmit,
        reset,
        formState: {
            errors,
            isSubmitting,
        }
    }: any = useForm({
        // начальные значения для формы
        defaultValues: {
            "database": getItemLocalStorage('remindPasswordBase') ?? "",
            "email": ""
        }
    });

    useEffect(() => {
        const fullConfig = getItemLocalStorage("fullConfig")
        let dataBases: any = []
        Object.keys(fullConfig).map((key: any) => {
            if (fullConfig[key].selectable) {
                dataBases.push({ prefix: key, name: fullConfig[key].company })
            }
        })
        dataBases.sort((a, b) => a?.name.localeCompare(b?.name))
        setDataBaseOptions(dataBases)
        reset()
    }, [])

    const errRef = useRef<HTMLInputElement>()
    const [loading, setLoading] = useState<any>();
    const [isSuccess, setIsSuccess] = useState<boolean>(false)

    // обработчик для кнопки "Вход"
    async function onSubmit(data: { database: any, email: string }) {
        setLoading(true)
        const fullConfig = getItemLocalStorage("fullConfig")
        const currentConfig = fullConfig[data.database]
        let apiUrl = currentConfig?.irosRestApiUrl
        let email = data.email
        try {
            const url = `${apiUrl}/security/account/restorePassword?Email='${email}'`;
            const response = await axios.get(url);
            const data = response.data;
            if (data.value) {
                setIsSuccess(true)
            }
            setLoading(false)
        } catch (error: any) {
            if (error?.response?.data?.error?.code === 'Forbidden') {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Аккаунт с указанным электронным адресом не существует', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            if (error?.response?.status === 502) {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Ошибка сервера', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            if (error?.response?.status !== 502 && error?.response?.data?.error?.code !== 'Forbidden') {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Проблемы с соединением', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            setIsSuccess(false)
            setLoading(false)
        }
    }

    return (
        <>
            {loading ? <Loader /> : <></>}
            <div>
                <ToastMessageContainer position="bottom-center" />
                <Header type="login" />
                <div className="login-page-back">
                    <div>
                        <div className="login-window remind">
                            <div className="login-window-top">
                                Восстановление пароля
                            </div>
                            <div className="login-window-main">
                                {!isSuccess
                                    ?
                                    <form onSubmit={handleSubmit(onSubmit)} >
                                        <div>
                                            <label className="d-flex flex-column">
                                                <span>База данных</span>
                                                {/* Поле выбора базы данных */}
                                                <select
                                                    {...register("database", {
                                                        required: "Выберите базу данных.",
                                                    })}
                                                    aria-invalid={errors["database"]}
                                                >
                                                    <option disabled value="">Выберите базу данных...</option>
                                                    {databaseOptions && databaseOptions.map((db: any) => {
                                                        if (getItemLocalStorage('remindPasswordBase') === db.prefix) {
                                                            return <option value={db.prefix} key={db.prefix} selected>{db.name}</option>
                                                        } else {
                                                            return <option value={db.prefix} key={db.prefix} >{db.name}</option>
                                                        }
                                                    })}
                                                </select>
                                                {errors["database"] &&
                                                    <p role="alert">{errors["database"]?.message}</p>}
                                            </label>
                                        </div>
                                        <div>
                                            <label className="d-flex flex-column">
                                                <span>E-mail</span>
                                                {/* Поле для ввода email */}
                                                <input
                                                    {...register("email", {
                                                        required: "Введите e-mail.",
                                                        validate: {
                                                            matchPattern: (v: any) =>
                                                                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                                                                "Неверный e-mail адрес",
                                                        },
                                                    })}
                                                    aria-invalid={errors["email"]}
                                                    placeholder="Введите e-mail..."
                                                    type="text"
                                                />
                                            </label>
                                            {errors["email"] && <p role="alert">{errors["email"]?.message}</p>}
                                        </div>
                                        <button disabled={isSubmitting}>Восстановить пароль</button>
                                    </form>
                                    :
                                    <div>
                                        <span className="success-message">На указанную почту в течение 10 минут будет отправлена инструкция по смене пароля.</span>
                                        <button onClick={() => navigate('/')} className="back-to-main-but">На главную</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
